Material = new THREE.MeshBasicMaterial()
class LevelInstance
  camera_z : 50
  @single_instance_mesh : (geometry, material, index, matrix) ->
    m = new THREE.InstancedMesh(geometry, material, 1)
    m.setMatrixAt 0, matrix
    m.geometry.setAttribute('instanceIndex', 
      new THREE.InstancedBufferAttribute(new Float32Array([index]), 1))
    m.name = "target"
    m
  get_z : () -> @camera_z
  constructor : (world, @renderer, @level) ->
    @level.init world
    count = @level.count

    if @level.mesh.children.length isnt 0
      i = 0
      for m in @level.mesh.children
        if m.geometry.setAttribute?
          l = if m.count? then m.count else 1
          indexes = new Float32Array([i..(i + l - 1)])
          indexesAttribute = new THREE.InstancedBufferAttribute(indexes, 1)
          m.geometry.setAttribute('instanceIndex', indexesAttribute)
          i += l
    else
      if @level.mesh.geometry.setAttribute?
        indexes = new Float32Array([0..count - 1])
        indexesAttribute = new THREE.InstancedBufferAttribute(indexes, 1)
        @level.mesh.geometry.setAttribute('instanceIndex', indexesAttribute)

    @camera = new T.PerspectiveCamera(140, innerWidth / innerHeight, 0.01, 700)

    @level.super = @

    @camera.position.set(0,0,@camera_z)
    @camera.lookAt(new THREE.Vector3(-10,0,-100))

    @scene = new THREE.Scene()
    @scene.add( @level.mesh )

  click : (intersection) ->
    if intersection?
      target = 
        if @level.validate?
          @level.validate intersection
        else
          intersection.object.name is "target" or intersection.instanceId is @level.target
      target

  resize : () ->
    @camera.aspect = innerWidth / innerHeight;
    @camera.updateProjectionMatrix()
  
  now : () -> new Date().getTime()

  update : ( dt, scroll) ->
    time = @now() * 0.00002
    time = (time - Math.floor(time)) * Math.PI * 2
    radius = 20
    @camera.position.set Math.cos(time) * radius, Math.sin(time) * radius, @camera_z
    @camera.lookAt(new THREE.Vector3(-10,0,-100))
    @level.update(dt, scroll)

Empty = 
  shader : "basic"
  init : (world) -> 
    radius = 200
    @count = 0


    @material = world.mats[@shader]
    @material.alphaTest = 0.6
    # @material.map = sprite
    @material.uniforms.color.value = new THREE.Color Colors.blue

    @mesh = new THREE.InstancedMesh( world.models.arrow.geometry, @material, @count );


    phase = 0

    m = new THREE.Matrix4()
    m.setPosition(0,0,0)
    ms = 0
    m.makeScale(ms, ms, ms)
    @mesh.setMatrixAt( 0, m)
    for i in [1..@count - 1]
      matrix = new THREE.Matrix4();
      t = (i / @count)
      radius = 30 + t * 140
      phase += 0.5 - 0.5 * (t)
      x = radius * Math.sin(phase);
      y = radius * Math.cos(phase);
      z = ( t) * 50;

      # scale = t * 39
      scale = 0
      matrix.makeScale(scale, scale, scale * 0.5)
      matrix.setPosition(x, y, z)
      @mesh.setMatrixAt( i, matrix )
    @mesh.position.set(0,0,0)
  update : (dt, scroll) ->
    @mesh.position.set(-50,0,0)
    @mesh.setRotationFromAxisAngle new THREE.Vector3(0, 0, 1), scroll

SpikesS = 
  line : (geom, material, dir, start, length, c, i = 0) ->
    m = new THREE.InstancedMesh(geom, material, c)
    s = 14
    z = 0
    for j in [0..c - 1]
      t = j / c
      matrix = new THREE.Matrix4();
      size = t * t * 100 + 0.5
      z += size + 4
      matrix.makeScale size,size,size
      matrix.setPosition start.x + dir.x * s * j - 50, start.y + dir.y * s * j, z - 100
      m.setMatrixAt j, matrix
    m
  shader : "basic"
  target : 10
  init : (world) -> 
    columns = 5
    rows = 30
    @count = columns * rows

    @material = world.mats[@shader]
    @material.alphaTest = 0.6
    @material.uniforms.color.value = new THREE.Color Colors.pink
    @material.uniforms.color2.value = new THREE.Color Colors.blue
    @material.uniforms.spatial_blend.value = new THREE.Vector3 0, 0.5, 1
    @material.uniforms.blend_freq.value = 0.1
    @material.uniforms.target.value = @target


    s = 10
    @mesh = new THREE.Group();
    for i in [0..columns - 1]
      phase = (i / columns) * Math.PI * 2
      x = Math.sin(phase)
      y = Math.cos(phase)
      dir = new THREE.Vector3(x, y, 0)
      center = 10
      start = new THREE.Vector3(x * center, y * center, 0)
      m = @line world.models.center.geometry.clone().scale(s,s,s * 1.8), @material, dir, start, 0, rows
      if i is 0
        m.name = "target"
      @mesh.add m
    @mesh.rotateOnAxis(new THREE.Vector3(0,0,1), 0.5)

  validate : (intersection) ->
    intersection.object.name is "target" and intersection.instanceId is @target
  update : (dt, scroll) ->
    v = @material.uniforms.color_offset.value
    v += dt * 0.2
    v -= Math.floor(v)
    @material.uniforms.color_offset.value = v
    @material.uniforms.color_shift.value = 1.0 - v

    # @mesh.position.set(-50,0,0)
    # for c, i in @mesh.children
    #   t = i / @mesh.children.length
    #   c.position.set(0,0,Math.sin(v * Math.PI * 2 + Math.PI * 2 * t) * 3)
    @mesh.rotateOnAxis(new THREE.Vector3(0,0,1), 0.0005)


Spikes = 
  line : (geom, material, dir, start, length, c, i = 0, target, target_fun) ->
    m = new THREE.InstancedMesh(geom, material, c)
    s = 17
    z = 0
    for j in [0..c - 1]
      t = j / c
      matrix = new THREE.Matrix4();
      size = t * t * 100 + 0.5
      z += size + 4
      matrix.makeScale size,size,size
      matrix.setPosition start.x + dir.x * s * j, start.y + dir.y * s * j, z - 100
      if i + j is target
        target_fun(matrix)
        matrix.makeScale 0,0,0
      m.setMatrixAt j, matrix
    m
  shader : "basic"
  init : (world) -> 
    columns = 4
    rows = 30
    @count = columns * rows


    @material = world.mats[@shader]
    @material.alphaTest = 0.6
    @material.uniforms.color.value = new THREE.Color Colors.aqua
    @material.uniforms.color2.value = new THREE.Color Colors.blue


    @mesh = new THREE.Group();
    for i in [0..columns - 1]
      phase = (i / columns) * Math.PI * 2
      x = Math.sin(phase)
      y = Math.cos(phase)
      dir = new THREE.Vector3(x, y, 0)
      center = 10
      start = new THREE.Vector3(x * center, y * center, 0)
      s = 10

      m = 
        if i is 0
          @line world.models.ring.geometry.clone().scale(s,s,s), @material, dir, start, 0, rows, i * rows, 7, (matrix) => @target_mat = matrix.clone()
        else
          @line world.models.ring.geometry.clone().scale(s,s,s), @material, dir, start, 0, rows, i * rows
      @mesh.add m

    s = 10
    @target_mesh = LevelInstance.single_instance_mesh(world.models.center.geometry.clone().scale(s,s,s), @material, @target, @target_mat)
    @mesh.add @target_mesh
    @mesh.rotateOnAxis(new THREE.Vector3(0,0,1), Math.PI * 0.5)

  update : (dt, scroll) ->
    v = @material.uniforms.color_offset.value
    v += dt * 0.1
    v -= Math.floor(v)
    @material.uniforms.color_offset.value = v

    @mesh.position.set(-50,0,0)
    @mesh.rotateOnAxis(new THREE.Vector3(0,0,1), 0.0005)
fact = (x) -> [1..x].reduce((a, v, i) -> a + v)

Circles3 = 
  target : 0
  init : (world) ->
  shader : "basic"
  init : (world) -> 
    radius = 200
    rings = 8

    @count = fact(rings - 1) + 19 * rings

    @material = world.mats[@shader]
    @material.alphaTest = 0.6
    @material.uniforms.color.value = new THREE.Color Colors.grey
    @material.uniforms.color2.value = new THREE.Color Colors.yellow
    @material.uniforms.blend_freq.value = 0.1
    i = 0
    s = 25
    @mesh = new THREE.InstancedMesh( world.models.arrow.geometry.clone().scale(s,s,s), @material, @count );
    o = 0.3
    for ring in [0..rings - 1]
      cells = ring + 19
      _z = ring * 16
      r = 70 + (ring * 18)
      for p in [0..cells - 1]
        t = p / cells
        _x = Math.cos(Math.PI * (t + o) * 2) * r
        _y = Math.sin(Math.PI * (t + o) * 2) * r
        matrix = new THREE.Matrix4();
        matrix.makeRotationAxis new THREE.Vector3(0,0,1), Math.PI * 2 * ((t + o) - 0.5)
        matrix.setPosition(_x, _y, _z - 80)
        @mesh.setMatrixAt i, matrix
        i += 1
  time : 0
  rot_index : 1
  update : (dt, scroll) ->
    t = @time + dt * 50.0
    s = 0.1

    if Math.floor(t) > Math.floor(@time)
      m = new THREE.Matrix4()
      @mesh.getMatrixAt(@rot_index, m)
      p = new THREE.Vector3().setFromMatrixPosition(m)
      r = new THREE.Euler().setFromRotationMatrix(m)
      m = new THREE.Matrix4()
      m.makeRotationAxis new THREE.Vector3(0,0,1), r.z + Math.PI
      m.setPosition p
      @mesh.setMatrixAt(@rot_index, m)
      @mesh.instanceMatrix.needsUpdate = true
      @rot_index = (@rot_index + 1) % @count
      if @rot_index is 0 then @rot_index = 1

    @material.uniforms.color_offset.value = fract(@material.uniforms.color_offset.value + dt * 0.25)
    #   @material.uniforms.color_shift.value = fract(@material.uniforms.color_shift.value - s)
    @time = t
    @mesh.setRotationFromEuler new THREE.Euler(0,0,scroll * Math.PI)


  

Circles4 = 
  target : 56
  shader : "basic"
  init : (world) -> 
    radius = 200
    @count = 200


    @material = world.mats[@shader]
    @material.alphaTest = 0.6
    @material.uniforms.color.value = new THREE.Color Colors.aqua
    @material.uniforms.color2.value = new THREE.Color Colors.blue
    @material.uniforms.blend_freq.value = 0.1

    @rings = new THREE.InstancedMesh( world.models.arrow.geometry.clone(), @material, @count );

    
    phase = 0

    m = new THREE.Matrix4()
    ms = 0
    m.makeScale(ms, ms, ms)
    m.setPosition(0,0,-10)
    @rings.setMatrixAt( 0, m)


    i = 1
    rows = 19
    r = 20
    target_pos = null
    target_scale = null
    while i < @count
      row_id = rows - 19
      for j in [0..rows - 1]
        if i >= @count then continue

        t = (i / @count)
        
        circ = Math.PI * 2 * r

        w = (circ / rows) * 1.2
        phase = (j / rows) * Math.PI * 2
        x = r * Math.sin(phase)
        y = r * Math.cos(phase)
        z = (r - 50) * 0.5

        matrix = new THREE.Matrix4();
        matrix.makeScale(w, w, w)
        matrix.setPosition(x, y, z)
        if i is @target
          target_pos = new THREE.Vector3(x,y,z)
          target_scale = w
          matrix.makeScale 0, 0, 0

        @rings.setMatrixAt( i, matrix )

        i++
      rows += 1
      r += w

    m = new THREE.Matrix4()
    # m.makeRotationAxis new THREE.Vector3(0,1,0), Math.PI * 0.4
    m.setPosition(target_pos.x, target_pos.y, target_pos.z)

    @target_mesh = LevelInstance.single_instance_mesh(world.models.arrow.geometry.clone().scale(target_scale, target_scale, target_scale), @material, @target, m)

    @mesh = new THREE.Group()
    @mesh.add @rings
    @mesh.add @target_mesh
    @target_mesh.position.set 0,0,0
  validate : (intersection) ->
    intersection.object.name is "target"
  update : (dt, scroll) ->
    v = @material.uniforms.color_offset.value
    v += dt * 0.1
    v -= Math.floor(v)
    @material.uniforms.color_offset.value = v

    @mesh.position.set(-40,0,scroll * 30)

Circles2 = 
  target : 56
  shader : "basic"
  init : (world) -> 
    radius = 200
    @count = 200


    @material = world.mats[@shader]
    @material.alphaTest = 0.6
    @material.uniforms.color.value = new THREE.Color Colors.aqua
    @material.uniforms.color2.value = new THREE.Color Colors.blue
    @material.uniforms.blend_freq.value = 0.1

    @rings = new THREE.InstancedMesh( world.models.one.geometry.clone(), @material, @count );

    
    phase = 0

    m = new THREE.Matrix4()
    ms = 0
    m.makeScale(ms, ms, ms)
    m.setPosition(0,0,-10)
    @rings.setMatrixAt( 0, m)


    i = 1
    rows = 19
    r = 20
    target_pos = null
    target_scale = null
    while i < @count
      row_id = rows - 19
      for j in [0..rows - 1]
        if i >= @count then continue

        t = (i / @count)
        
        circ = Math.PI * 2 * r

        w = (circ / rows) * 1.2
        phase = (j / rows) * Math.PI * 2
        x = r * Math.sin(phase)
        y = r * Math.cos(phase)
        z = (r - 50) * 0.5

        matrix = new THREE.Matrix4();
        matrix.makeScale(w, w, w)
        matrix.setPosition(x, y, z)
        if i is @target
          target_pos = new THREE.Vector3(x,y,z)
          target_scale = w
          matrix.makeScale 0, 0, 0

        @rings.setMatrixAt( i, matrix )

        i++
      rows += 1
      r += w

    m = new THREE.Matrix4()
    m.makeRotationAxis new THREE.Vector3(0,1,0), Math.PI * 0.4
    m.setPosition(target_pos.x, target_pos.y, target_pos.z)

    @target_mesh = LevelInstance.single_instance_mesh(world.models.one.geometry.clone().scale(target_scale, target_scale, target_scale), @material, @target, m)

    @mesh = new THREE.Group()
    @mesh.add @rings
    @mesh.add @target_mesh
    @target_mesh.position.set 0,0,0
  validate : (intersection) ->
    intersection.object.name is "target"
  update : (dt, scroll) ->
    v = @material.uniforms.color_offset.value
    v += dt * 0.1
    v -= Math.floor(v)
    @material.uniforms.color_offset.value = v

    @mesh.position.set(-40,0,scroll * 30)

Circles = 
  target : 97
  shader : "basic"
  init : (world) -> 
    radius = 200
    @count = 200


    @material = world.mats[@shader]
    @material.alphaTest = 0.6
    @material.uniforms.color.value = new THREE.Color Colors.aqua
    @material.uniforms.color2.value = new THREE.Color Colors.blue
    @material.uniforms.blend_freq.value = 0.1

    @rings = new THREE.InstancedMesh( world.models.one.geometry.clone(), @material, @count );

    
    phase = 0

    m = new THREE.Matrix4()
    ms = 0
    m.makeScale(ms, ms, ms)
    m.setPosition(0,0,-10)
    @rings.setMatrixAt( 0, m)


    i = 1
    rows = 19
    r = 20
    target_pos = null
    target_scale = null
    while i < @count
      row_id = rows - 19
      for j in [0..rows - 1]
        if i >= @count then continue

        t = (i / @count)
        
        circ = Math.PI * 2 * r

        w = (circ / rows) * 1.2
        phase = (j / rows) * Math.PI * 2
        x = r * Math.sin(phase)
        y = r * Math.cos(phase)
        z = (r - 50) * 0.5

        matrix = new THREE.Matrix4();
        matrix.makeScale(w, w, w)
        matrix.setPosition(x, y, z)
        if i is @target
          target_pos = new THREE.Vector3(x,y,z)
          target_scale = w
          matrix.makeScale 0, 0, 0

        @rings.setMatrixAt( i, matrix )

        i++
      rows += 1
      r += w

    m = new THREE.Matrix4()
    # m.makeRotationAxis new THREE.Vector3(0,1,0), Math.PI * 0.4
    m.setPosition(target_pos.x, target_pos.y, target_pos.z)

    @target_mesh = LevelInstance.single_instance_mesh(world.models.nine.geometry.clone().scale(target_scale, target_scale, target_scale), @material, @target, m)

    @mesh = new THREE.Group()
    @mesh.add @rings
    @mesh.add @target_mesh
    @target_mesh.position.set 0,0,0
  validate : (intersection) ->
    intersection.object.name is "target"
  update : (dt, scroll) ->
    v = @material.uniforms.color_offset.value
    v += dt * 0.1
    v -= Math.floor(v)
    @material.uniforms.color_offset.value = v

    @mesh.position.set(-40,0,scroll * 30)

Triangle = 
  target : 32
  count : 300
  triangle : (geometry, material, c) ->
    m = new THREE.InstancedMesh( geometry, material, c);

    phase = 0
    w = 10
    row = 0
    ys = 14
    j = 0
    for i in [0..@count - 1]
      z = 0
      matrix = new THREE.Matrix4();
      matrix.makeScale(w, w, w)
      matrix.setPosition(j * (w + 10) - 100, row * ys - 150, j * 12 - 25)
      m.setMatrixAt( i, matrix )

      j++
      if j > row
        j = 0
        row++
    m.count = c
    m
  shader : "vibrate"
  init : (world) -> 


    @mesh = new THREE.Group()

    @material = world.mats.vibrate.clone()
    @material.alphaTest = 0.6
    @material.uniforms.color.value = new THREE.Color Colors.grey
    @material.uniforms.color2.value = new THREE.Color Colors.red
    @material.uniforms.target.value = @target

    @nines = @triangle world.models.nine.geometry.clone(), @material, @count / 2
    @ones = @triangle world.models.one.geometry.clone(), @material, @count / 2
    @mesh.add @nines
    @mesh.add @ones
    @ones.translateZ 10
    # @mesh.rotateOnAxis(new THREE.Vector3(0, 0, 1), Math.PI * 0.5)
  update : (dt, scroll) ->
    @material.uniforms.u_time.value = @material.uniforms.u_time.value + dt

Triangle2 = 
  target : 95
  count : 300
  triangle : (geometry, material, c) ->
    m = new THREE.InstancedMesh( geometry, material, c);

    phase = 0
    w = 10
    row = 0
    ys = 14
    j = 0
    for i in [0..@count - 1]
      z = 0
      matrix = new THREE.Matrix4();
      matrix.makeScale(w, w, w)
      matrix.setPosition(j * (w + 10) - 100, row * ys - 150, j * 12 - 25)
      m.setMatrixAt( i, matrix )

      j++
      if j > row
        j = 0
        row++
    m.count = c
    m
  shader : "vibrate"
  init : (world) -> 


    @mesh = new THREE.Group()

    @material = world.mats.vibrate.clone()
    @material.alphaTest = 0.6
    @material.uniforms.color.value = new THREE.Color Colors.grey
    @material.uniforms.color2.value = new THREE.Color Colors.red
    @material.uniforms.target.value = @target
    @material.uniforms.vibrate_select.value = 1.0
    @material.uniforms.vibration.value = 0.1

    @nines = @triangle world.models.one.geometry.clone(), @material, @count / 2
    @ones = @triangle world.models.nine.geometry.clone(), @material, @count / 2
    @mesh.add @nines
    @mesh.add @ones
    @ones.translateZ 10
    # @mesh.rotateOnAxis(new THREE.Vector3(0, 0, 1), Math.PI * 0.5)
  update : (dt, scroll) ->
    @material.uniforms.u_time.value = @material.uniforms.u_time.value + dt


Tube = 
  target : 43
  shader : "basic"
  init : (world) -> 

    radius = 50
    @count = 300


    @material = world.mats[@shader]
    @material.alphaTest = 0.6
    @material.uniforms.color.value = new THREE.Color Colors.grey
    @material.uniforms.color2.value = new THREE.Color Colors.yellow
    @material.uniforms.target.value = @target
    @material.uniforms.color_shift.value = 0.8
    @material.uniforms.blend_freq.value = 0.1


    @mesh = new THREE.InstancedMesh( world.models.nine.geometry, @material, @count );

    phase = 0

    m = new THREE.Matrix4()
    ms = 0
    m.makeScale(ms, ms, ms)
    m.setPosition(0,0,-10)
    @mesh.setMatrixAt( 0, m)

    i = 1
    rows = 19
    r = 100
    while i < @count
      row_id = rows - 19
      for j in [0..rows - 1]
        if i >= @count then return
        matrix = new THREE.Matrix4();
        t = (i / @count)
        circ = Math.PI * 2 * r
        w = (circ / rows) * 1.1

        phase = (j / rows) * Math.PI * 2
        x = row_id * w * 2
        z = r * Math.sin(phase)
        y = r * Math.cos(phase)

        matrix.makeRotationAxis new THREE.Vector3(0,1,0), 0
        matrix.makeScale(w, w, w)
        matrix.setPosition(x - 300, y, z)
        @mesh.setMatrixAt( i, matrix )
        i++
      rows += 1
      r += 1
  update : (dt, scroll) ->
    @material.uniforms.spatial_blend.value = new THREE.Vector3 0,0,(scroll)

    @mesh.position.set(0, 0, -100)

Tube2 = 
  target : 143
  shader : "basic"
  init : (world) -> 

    radius = 50
    @count = 300


    @material = world.mats[@shader]
    @material.alphaTest = 0.6
    @material.uniforms.color.value = new THREE.Color Colors.grey
    @material.uniforms.color2.value = new THREE.Color Colors.yellow
    @material.uniforms.target.value = @target
    @material.uniforms.color_shift.value = 0.0
    @material.uniforms.blend_freq.value = 0.1

    ss = 34
    @mesh = new THREE.InstancedMesh( world.models.one.geometry.clone().scale(ss,ss,ss), @material, @count );

    phase = 0

    m = new THREE.Matrix4()
    ms = 0
    m.makeScale(ms, ms, ms)
    m.setPosition(0,0,-10)
    @mesh.setMatrixAt( 0, m)

    i = 1
    rows = 19
    w = 15
    r = 100
    while i < @count
      row_id = rows - 19
      for j in [0..rows - 1]
        if i >= @count then return
        matrix = new THREE.Matrix4();
        t = (i / @count)
        circ = Math.PI * 2 * r

        phase = (j / rows) * Math.PI * 2
        x = row_id * w * 2
        z = r * Math.sin(phase)
        y = r * Math.cos(phase)

        if i is @target 
          matrix.makeRotationAxis new THREE.Vector3(0,0,1), Math.PI * 0.5
        matrix.setPosition(x - 200, y, z)
        @mesh.setMatrixAt( i, matrix )
        i++
      rows += 1
      r += 1
  update : (dt, scroll) ->
    @material.uniforms.spatial_blend.value = new THREE.Vector3 0,0,(scroll)
    @mesh.rotateOnAxis(new THREE.Vector3(1, 0, 0), dt * 0.1)
    @mesh.position.set(0, 0, 30)

Arrows = 
  target : 170
  shader : "basic"
  init : (world) -> 

    radius = 200
    @count = 200

    @material = world.mats[@shader]
    @material.alphaTest = 0.6
    @material.uniforms.color.value = new THREE.Color Colors.green
    @material.uniforms.blend_freq.value = 0.1

    @material.uniforms.color2.value = new THREE.Color Colors.aqua

    @mesh = new THREE.InstancedMesh( world.models.arrow.geometry, @material, @count );

    phase = 0
    grid = 
      w : 10
      h : 10
    g = 
      w : radius / grid.w
      h : radius / grid.h
    size = 
      w : radius * 0.5
      h : radius * 0.5
    for i in [1..@count]
      matrix = new THREE.Matrix4();
      t = (i / @count)
      r = 10 + t * 1
      phase += 0.5 - 0.2 * (t)
      x = Math.floor(i % grid.w) * g.w - size.w
      if i is @target
        x -= 50
      y = Math.floor(i / grid.h) * g.h - size.h

      z = Math.random() * 8;

      scale = 20
      matrix.makeScale(scale, scale, scale)
      matrix.setPosition(x, y, z)
      @mesh.setMatrixAt( i, matrix )
  update : (dt, scroll) ->
    radius = 200

    @mesh.position.set(0,scroll * -200,0);


ArrowsS = 
  target : 62
  shader : "basic"
  init : (world) -> 

    radius = 200
    @count = 200

    @material = world.mats[@shader]
    @material.alphaTest = 0.6
    @material.uniforms.color.value = new THREE.Color Colors.green
    @material.uniforms.blend_freq.value = 0.1

    @material.uniforms.color2.value = new THREE.Color Colors.aqua

    @mesh = new THREE.InstancedMesh( world.models.arrow.geometry, @material, @count );

    phase = 0
    grid = 
      w : 10
      h : 10
    g = 
      w : radius / grid.w
      h : radius / grid.h
    size = 
      w : radius * 0.5
      h : radius * 0.5
    for i in [1..@count]
      matrix = new THREE.Matrix4();
      t = (i / @count)
      r = 10 + t * 1
      phase += 0.5 - 0.2 * (t)
      x = Math.floor(i % grid.w) * g.w - size.w
      y = Math.floor(i / grid.h) * g.h - size.h
      z = Math.random() * 15;

      scale = 20
      if i is @target 
        scale = 40
        z = 5
      matrix.makeScale(scale, scale, scale)
      matrix.setPosition(x, y, z)
      @mesh.setMatrixAt( i, matrix )
  update : (dt, scroll) ->
    radius = 200

    @mesh.position.set(0,scroll * -200,0);

ArrowsR = 
  target : 93
  shader : "basic"
  init : (world) -> 

    radius = 200
    @count = 200

    @material = world.mats[@shader]
    @material.alphaTest = 0.6
    @material.uniforms.color.value = new THREE.Color Colors.green
    @material.uniforms.blend_freq.value = 0.1
    @material.uniforms.target.value = @target

    @material.uniforms.color2.value = new THREE.Color Colors.aqua
    s = 20
    @mesh = new THREE.InstancedMesh( world.models.arrow.geometry.clone().scale(s,s,s * 0.4), @material, @count );

    phase = 0
    grid = 
      w : 10
      h : 10
    g = 
      w : radius / grid.w
      h : radius / grid.h
    size = 
      w : radius * 0.5
      h : radius * 0.5
    for i in [1..@count]
      matrix = new THREE.Matrix4();
      t = (i / @count)
      r = 10 + t * 1
      phase += 0.5 - 0.2 * (t)
      x = Math.floor(i % grid.w) * g.w - size.w
      # if i is @target
      #   x -= 40
      y = Math.floor(i / grid.h) * g.h - size.h
      z = Math.random();
      if i is @target 
        z = 0.95
        matrix.makeRotationAxis new THREE.Vector3(0,0,-1), Math.PI * (-0.5)
      else
        matrix.makeRotationAxis new THREE.Vector3(0,0,-1), Math.PI * (-0.5 - z)
      matrix.setPosition(x, y, z * 30)
      @mesh.setMatrixAt( i, matrix )
  update : (dt, scroll) ->
    radius = 200
    @mesh.position.set(0,scroll * -200,0);

Crosses3 = 
  target : 100
  cross : (segments, c, x, y, w, zs, geom, material) ->
    # world.models.nine.geometry
    @count = c * 4 * 2 * segments
    ws = 35
    m = new THREE.InstancedMesh( geom.clone().scale(ws,ws,ws), material, @count);

    i = 0

    for s in [0..segments - 1]
      _z = s * zs
      r = 30
      phase = 0
      r2 = r * 0.5
      j = 0
      o = 0

      for j in [0..c - 1]
        for p in [0..3]
          t = p / 4
          _x = Math.cos(Math.PI * t * 2) * r
          _y = Math.sin(Math.PI * t * 2) * r
          matrix = new THREE.Matrix4();
          matrix.makeRotationAxis new THREE.Vector3(0,0,1), Math.PI * 2 * (t - 0.5)
          matrix.setPosition(x + _x + o, y + _y + o, _z - 200)
          m.setMatrixAt i, matrix
          i += 1
        r += w
    m
  shader : "basic"
  init : (world) -> 
    @material = world.mats[@shader]
    @material.alphaTest = 0.6
    @material.uniforms.color.value = new THREE.Color Colors.grey
    @material.uniforms.color2.value = new THREE.Color 0xffffff
    @material.uniforms.target.value = @target
    @material.uniforms.blend_freq.value = 0.1
    # @material.uniforms.spatial_blend.value = new THREE.Vector3 0,1,0

    @mesh = @cross(8, 4, 0,0,50, 40, world.models.arrow.geometry, @material)
  set_x : (m, x) ->
    m.position.set x, m.position.y, m.position.z
  time : 0
  update : (dt, scroll) ->
    s2 = 30
    t = @time + dt * 2.0
    s = 0.1
    if Math.floor(t) > Math.floor(@time)
      @material.uniforms.color_offset.value = fract(@material.uniforms.color_offset.value + s)
      @material.uniforms.color_shift.value = fract(@material.uniforms.color_shift.value - s)
    @time = t
    @mesh.rotateOnAxis(new THREE.Vector3(0, 0, 1), dt * 0.1);
    @mesh.position.set(-20,-s2 + scroll * s2 * 2, -70);


Crosses2 = 
  target : 117
  cross : (segments, c, x, y, w, zs, geom, material, target) ->
    # world.models.nine.geometry
    cs = 6
    @count = c * cs * segments
    ws = 25
    m = new THREE.InstancedMesh( geom.clone().scale(ws,ws,ws), material, @count);

    i = 0

    for s in [0..segments - 1]
      _z = s * zs
      r = 30
      phase = 0
      r2 = r * 0.5
      j = 0
      o = 0

      colors = [
        new THREE.Color Colors.pink
        new THREE.Color Colors.grey
      ]

      for j in [0..c - 1]
        jt = j / c
        for p in [0..cs - 1]
          t = p / cs
          t += (1.0 - Math.random() * 2.0) * 0.1 * jt
          _x = Math.cos(Math.PI * t * 2) * r
          _y = Math.sin(Math.PI * t * 2) * r
          matrix = new THREE.Matrix4();
          matrix.makeRotationAxis new THREE.Vector3(0,0,1), Math.PI * 2 * (t - 0.25)
          matrix.setPosition(x + _x + o, y + _y + o, _z - segments * zs * 0.61)
          m.setMatrixAt i, matrix
          
          m.setColorAt i, colors[(if target? and i is target then j+1 else j)%2]
          i += 1
        r += w
    m
  shader : "color"
  init : (world) -> 
    @material = world.mats[@shader]
    @material.alphaTest = 0.6
    @material.uniforms.color.value = new THREE.Color Colors.grey
    @material.uniforms.color2.value = new THREE.Color Colors.pink
    @material.uniforms.target.value = @target
    @material.uniforms.blend_freq.value = 0.5
    # @material.uniforms.spatial_blend.value = new THREE.Vector3 0,1,0
    @mesh = new THREE.Group()
    @a = @cross(4, 6, 0,0,30, 80, world.models.nine.geometry, @material, @target)
    @b = @cross(4, 6, 0,0,30, 80, world.models.one.geometry, @material)
    @a.translateZ 40
    @mesh.add @a
    @mesh.add @b

  time : 0
  update : (dt, scroll) ->
    s2 = 30
    # t = @time + dt * 2.0
    # s = 0.1
    # if Math.floor(t) > Math.floor(@time)
    #   @material.uniforms.color_offset.value = fract(@material.uniforms.color_offset.value + s)
    @material.uniforms.color_offset.value = fract(@material.uniforms.color_offset.value + dt * 0.2)
    @material.uniforms.color_shift.value = 1.0
    # @time = t
    # @mesh.rotateOnAxis(new THREE.Vector3(0, 0, 1), dt * 0.1);
    @a.rotateOnAxis(new THREE.Vector3(0, 0, -1), dt * 0.05);
    @b.rotateOnAxis(new THREE.Vector3(0, 0, 1), dt * 0.05);
    @mesh.position.set(-20,-s2 + scroll * s2 * 2, -70);

Crosses = 
  target : 105
  cross : (segments, c, x, y, w, zs, geom, material) ->
    # world.models.nine.geometry
    @count = c * 2 * segments
    m = new THREE.InstancedMesh( geom, material, @count);

    i = 0

    for s in [0..segments - 1]
      _z = s * zs
      radius = 200
      r = radius
      phase = 0
      r2 = radius * 0.5
      width = (w / c)
      j = 0
      o = width
      ws = width * 2.0
      while j < c
        matrix = new THREE.Matrix4();
        _x = j * width - w * 0.5
        _y = -width
        matrix.makeScale(ws, ws, ws)
        matrix.setPosition(x + _x + o, y + _y + o, _z)
        m.setMatrixAt i, matrix

        matrix = new THREE.Matrix4();
        _x = -width
        _y = j * width - w * 0.5
        matrix.makeScale(ws, ws, ws)
        matrix.setPosition(x + _x + o, y + _y + o, _z)
        m.setMatrixAt i + 1, matrix
        j += 2;
        i += 2

    return m
  shader : "basic"
  init : (world) -> 
    @material = world.mats[@shader]
    @material.alphaTest = 0.6
    @material.uniforms.color.value = new THREE.Color Colors.pink
    @material.uniforms.color2.value = new THREE.Color Colors.white
    @material.uniforms.target.value = @target
    @material.uniforms.blend_freq.value = 1.0

    @mesh = @cross(8, 18, 0,0,100, 16, world.models.one.geometry, @material)
  set_x : (m, x) ->
    m.position.set x, m.position.y, m.position.z
  update : (dt, scroll) ->
    s2 = 30
    # @material.uniforms.u_time.value = @material.uniforms.u_time.value + dt
    @material.uniforms.color_offset.value = fract(@material.uniforms.color_offset.value + dt * 0.1)
    @material.uniforms.color_shift.value = fract(@material.uniforms.color_shift.value + dt * 0.1)
    @mesh.rotateOnAxis(new THREE.Vector3(0, 0, 1), dt * 0.1);
    @mesh.position.set(-20,-s2 + scroll * s2 * 2, -70);

Grid = 
  wall : (wc, hc, x, y, w, h, geom, material, target = -1, target_fun) ->
    # world.models.nine.geometry
    c = wc * hc

    radius = 200
    r = radius
    phase = 0
    r2 = radius * 0.5
    width = (w / wc)
    height = (h / hc)

    m = new THREE.InstancedMesh( geom, material, c);
    for yi in [0..hc - 1]
      for xi in [0..wc - 1]
        i = yi * wc + xi
        matrix = new THREE.Matrix4();
        _x = Math.floor(xi % wc) * width
        _y = -yi * height
        _z = 0;
        if target? and target is i
          target_fun(matrix)
        matrix.setPosition(x + _x, y + _y, _z)
        m.setMatrixAt( i, matrix )
    return m

  target : 9
  shader : "basic"
  init : (world) -> 
    @count = 9 * 9

    w = 120


    @material = world.mats[@shader]
    @material.alphaTest = 0.6
    @material.uniforms.color.value = new THREE.Color Colors.aqua
    @material.uniforms.color2.value = new THREE.Color Colors.blue
    @material.uniforms.spatial_blend.value = new THREE.Vector3 0,0,0
    @material.uniforms.blend_freq.value = 0.1


    @mesh = new THREE.Group()
    wid = w / 9

    @geo_bottom = world.models.nine.geometry.clone().scale(wid, wid, wid)
    @geo_top = world.models.nine.geometry.clone().scale(wid, wid, wid)

    @mesh_bottom = @wall(9, 5, 0,0,w, w, 
      @geo_bottom, 
      @material, 
      @target, 
      (m) -> 
        m.makeRotationAxis new THREE.Vector3(0,0,1), Math.PI 
    )
    @mesh_bottom.name = "bottom"
    @material.uniforms.target.value = @target

    @mesh_top = @wall(9, 4, 0,w,w,w, @geo_top, @material)

    @mesh.add @mesh_bottom
    @mesh.add @mesh_top

    @mesh.position.set(-100,-10,0)
  validate : (intersection) ->
    intersection.object.name is "bottom" and intersection.instanceId is @target
  set_x : (m, x) ->
    m.position.set x, m.position.y, m.position.z
  update : (dt, scroll) ->
    s2 = 107
    @set_x @mesh_top, -s2 + scroll * s2
    @set_x @mesh_bottom, -s2 + (1 - scroll) * s2
    @mesh_top.position.set
    @mesh.position.set(0,-20, 0);

GridR = 
  wall : (wc, hc, x, y, w, h, geom, material, target = -1, target_fun) ->
    rots = [0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8]
    c = wc * hc

    radius = 200
    r = radius
    phase = 0
    r2 = radius * 0.5
    width = (w / wc)
    height = (h / hc)

    m = new THREE.InstancedMesh( geom, material, c);
    for yi in [0..hc - 1]
      for xi in [0..wc - 1]
        i = yi * wc + xi
        matrix = new THREE.Matrix4();
        _x = Math.floor(xi % wc) * width
        _y = -yi * height
        _z = 0;
        if target? and target is i
          target_fun(matrix)
        else
          matrix.makeRotationAxis new THREE.Vector3(0,0,1), Math.PI * ranfrom(rots)
        matrix.setPosition(x + _x, y + _y, _z)
        m.setMatrixAt( i, matrix )
    return m

  target : 13
  shader : "basic"
  init : (world) -> 
    @count = 9 * 9

    w = 120


    @material = world.mats[@shader]
    @material.alphaTest = 0.6
    @material.uniforms.color.value = new THREE.Color Colors.aqua
    @material.uniforms.color2.value = new THREE.Color Colors.blue
    @material.uniforms.spatial_blend.value = new THREE.Vector3 0,0,0
    @material.uniforms.blend_freq.value = 0.1


    @mesh = new THREE.Group()
    wid = w / 9

    @geo_bottom = world.models.one.geometry.clone().scale(wid, wid, wid)
    @geo_top = world.models.one.geometry.clone().scale(wid, wid, wid)

    @mesh_bottom = @wall(9, 5, 0,0,w, w, 
      @geo_bottom, 
      @material
    )
    @mesh_bottom.name = "bottom"

    @material.uniforms.target.value = @target
    f = (m) -> m.makeRotationAxis new THREE.Vector3(0,0,1), 0 
    @mesh_top = @wall(9, 4, 0,w,w,w, @geo_top, @material, @target, f)
    @mesh_top.name = "top"
    @mesh.add @mesh_bottom
    @mesh.add @mesh_top

    @mesh.position.set(-100,-10,0)
  validate : (intersection) ->
    intersection.object.name is "top" and intersection.instanceId is @target
  set_x : (m, x) ->
    m.position.set x, m.position.y, m.position.z
  update : (dt, scroll) ->
    s2 = 107
    @set_x @mesh_top, -s2 + scroll * s2
    @set_x @mesh_bottom, -s2 + (1 - scroll) * s2
    @mesh_top.position.set
    @mesh.position.set(0,-20, 0);


GridC = 
  wall : (wc, hc, x, y, w, h, geom, material, target = -1, target_fun) ->
    rots = [0.1, 0.2, 0.3, 0.4, 0.6, 0.7, 0.8, 0.9]
    # world.models.nine.geometry
    c = wc * hc

    radius = 200
    r = radius
    phase = 0
    r2 = radius * 0.5
    width = (w / wc)
    height = (h / hc)

    m = new THREE.InstancedMesh( geom, material, c);
    for yi in [0..hc - 1]
      for xi in [0..wc - 1]
        i = yi * wc + xi
        matrix = new THREE.Matrix4();
        _x = Math.floor(xi % wc) * width
        _y = -yi * height
        _z = 0;
        inverted = Math.random() > 0.5
        if inverted
          matrix.makeRotationAxis new THREE.Vector3(0,1,0), Math.PI
          m.setColorAt i, new THREE.Color(Colors.pink)
        else
          m.setColorAt i, new THREE.Color(Colors.aqua)

        if target? and target is i
          m.setColorAt i, new THREE.Color(if inverted then Colors.aqua else Colors.pink)
        #   target_fun(matrix)
        # else
        #   matrix.makeRotationAxis new THREE.Vector3(0,0,1), Math.PI * ranfrom(rots)
        matrix.setPosition(x + _x, y + _y, _z)
        m.setMatrixAt( i, matrix )
    return m

  target : 19
  shader : "color"
  init : (world) -> 
    @count = 9 * 9

    w = 120


    @material = world.mats[@shader]
    @material.alphaTest = 0.6
    @material.uniforms.color.value = new THREE.Color Colors.aqua
    @material.uniforms.color2.value = new THREE.Color Colors.blue
    @material.uniforms.spatial_blend.value = new THREE.Vector3 0,0,0
    @material.uniforms.blend_freq.value = 0.1


    @mesh = new THREE.Group()
    wid = w / 9

    @geo_bottom = world.models.arrow.geometry.clone().scale(wid, wid, wid)
    @geo_top = world.models.arrow.geometry.clone().scale(wid, wid, wid)

    @mesh_bottom = @wall 9, 5, 0,0,w, w, @geo_bottom, @material, @target
    @mesh_bottom.name = "bottom"

    @material.uniforms.target.value = @target
    @mesh_top = @wall 9, 4, 0,w,w,w, @geo_top, @material
    @mesh_top.name = "top"
    @mesh.add @mesh_bottom
    @mesh.add @mesh_top

    @mesh.position.set(-100,-10,0)
  validate : (intersection) ->
    intersection.object.name is "bottom" and intersection.instanceId is @target
  set_x : (m, x) ->
    m.position.set x, m.position.y, m.position.z
  update : (dt, scroll) ->
    s2 = 107
    @set_x @mesh_top, -s2 + scroll * s2
    @set_x @mesh_bottom, -s2 + (1 - scroll) * s2
    @mesh_top.position.set
    @mesh.position.set(0,-20, 0);
Ending = 
  validate : (intersection) -> false
  init : (world) ->
    r = 250
    @mesh = new THREE.Mesh(new THREE.PlaneGeometry(r * 2.3,r * 2.3,1), new THREE.MeshBasicMaterial(map : new THREE.TextureLoader().load("assets/logo/logo.png")), transparent : true, alpaTest : 0.6)
    @mesh.position.set -100,0,-82
  update : (dt, scroll) ->

Final = 
  target : 58
  init : (world) ->
  shader : "normal"
  init : (world) -> 
    @material = world.mats[@shader]
    @material.alphaTest = 0.6
    @material.uniforms.color.value = new THREE.Color Colors.blue
    @material.uniforms.color2.value = new THREE.Color Colors.white
    @material.uniforms.blend_freq.value = 0.1
    i = 0
    s = 25

    ring = 38
    r = 250
    pos = []
    for p in [0..ring - 1]
      t = p / ring
      x = Math.cos(Math.PI * t * 2) * r
      y = Math.sin(Math.PI * t * 2) * r
      z = 0
      pos.push new THREE.Vector3(x,y, z)

    sr = 65
    sring = 11
    for p in [0..sring - 1]
      t = p / sring
      o = 0.3
      x = Math.cos(Math.PI * t * 2 + o) * sr
      y = Math.sin(Math.PI * t * 2 + o) * sr
      z = 0
      pos.push new THREE.Vector3(x + r * 0.6,y + r * 0.3, z)

    l = 5
    for i in [0..l - 1]
      t = i / l
      a = new THREE.Vector3(r * 0.88, r * 0.12, 0)
      b = new THREE.Vector3(r * 0.43, - r * 0.5, 0)
      pos.push new THREE.Vector3().lerpVectors(a, b, t)

    l = 8
    for i in [0..l - 1]
      t = i / l
      a = new THREE.Vector3(r * 0.09, r * 0.5, 0)
      b = new THREE.Vector3(r * 0.09, - r * 0.5, 0)
      pos.push new THREE.Vector3().lerpVectors(a, b, t)

    l = 4
    for i in [0..l - 1]
      t = i / l
      a = new THREE.Vector3(r * 0.09, r * 0.5, 0)
      b = new THREE.Vector3(-r * 0.3, r * 0.3, 0)
      if i > 0
        pos.push new THREE.Vector3().lerpVectors(a, b, t)


    l = 5
    for i in [0..l - 1]
      t = i / l
      a = new THREE.Vector3(-r * 1, 0, 0)
      b = new THREE.Vector3(-r * 0.3, r * 0.3, 0)
      if i > 0
        pos.push new THREE.Vector3().lerpVectors(a, b, t)

    l = 5
    for i in [0..l - 1]
      t = i / l
      a = new THREE.Vector3(-r * 1, 0, 0)
      b = new THREE.Vector3(-r * 0.3, -r * 0.3, 0)
      if i > 0
        pos.push new THREE.Vector3().lerpVectors(a, b, t)


    @count = pos.length
    @mesh = new THREE.Group()
    @logo = new THREE.InstancedMesh( world.models.logo.geometry.clone().scale(s,s,s * 0.3), @material, @count );
    col = new THREE.Color 0xffffff
    for p, i in pos
      t = Math.random()
      matrix = new THREE.Matrix4();
      matrix.makeRotationAxis new THREE.Vector3(0,0,1), Math.PI * 2 * (t + 0.5)
      matrix.setPosition(p.x, p.y, p.z - 80)
      @logo.setMatrixAt i, matrix
      @logo.setColorAt i, col


    @logo.position.set(-100, 0, 0)
    # @back = new THREE.Mesh(new THREE.PlaneGeometry(sr * 1.6,sr * 1.6,1), new THREE.MeshBasicMaterial(map : new THREE.TextureLoader().load("assets/logo/logo.png")), transparent : true, alpaTest : 0.5)
    @mesh.add @logo
  time : 0
  rot_index : 1
  hover : (h) ->
    if h? and h.instanceId isnt @target
      m = new THREE.Matrix4()
      m.makeScale(0,0,0)
      @logo.setMatrixAt h.instanceId, m
      @logo.instanceMatrix.needsUpdate = true
      true
    else
      false

  update : (dt, scroll) ->



WinR = 
  target : 105
  ring : (c, z, radius, geom, mat) ->
    scale = 60
    m = new THREE.InstancedMesh( geom.clone().scale(scale, scale, scale * 10), mat, @count );
    for i in [0..c - 1]
      t = i / c
      matrix = new THREE.Matrix4();
      x = Math.cos(t * Math.PI * 2.0) * radius
      y = Math.sin(t * Math.PI * 2.0) * radius
      matrix.setPosition x, y, z
      m.setMatrixAt( i, matrix )
    m

  plain : (geom, columns, rows, width, depth, scale, random_y, mat) -> 
    radius = 250
    @count = columns * rows
    m = new THREE.InstancedMesh( geom.clone().scale(scale, scale, scale), mat, @count );

    w = width / columns
    h = depth / rows
    yh = 30 * random_y
    for i in [1..@count]
      matrix = new THREE.Matrix4();
      x = Math.floor(i % columns) * w + Math.random() * 300

      # y = i
      # y = 0;
      y = yh + Math.random() * - yh * 2

      z = i
      # z = - Math.floor(i / columns) * h
      matrix.setPosition(x, y, z)
      m.setMatrixAt( i, matrix )
    m

  dunes : (geom, material) -> 
    radius = 250
    scale = 40
    @count = 100
    m = new THREE.InstancedMesh( geom.clone().scale(scale, scale, scale), material, @count);

    phase = 0
    grid = 
      w : 10
      h : 10
    g = 
      w : radius / grid.w
      h : radius / grid.h
    size = 
      w : radius * 0.5
      h : radius * 0.5
    for i in [1..@count]
      matrix = new THREE.Matrix4();
      t = (i / @count)
      r = 10 + t * 1
      phase += 0.5 - 0.2 * (t)
      x = Math.floor(i % grid.w) * g.w - size.w
      if i is @target
        x -= 50
      
      y = Math.random() * 8 + i;

      z = -i * 3 - (i % 3) * 4#Math.floor(i / grid.h) * g.h - size.h + Math.random() * 8;


      # matrix.makeScale(scale, scale, scale)

      # matrix.makeRotationAxis new THREE.Vector3(0,0,-2), Math.PI
      matrix.setPosition(x, y, z)
      m.setMatrixAt( i, matrix )
    m
  cross : (segments, c, x, y, w, zs, geom, material) ->
    # world.models.nine.geometry
    @count = c * 2 * segments
    m = new THREE.InstancedMesh( geom, material, @count);

    i = 0

    for s in [0..segments - 1]
      _z = s * zs
      radius = 200
      r = radius
      phase = 0
      r2 = radius * 0.5
      width = (w / c)
      j = 0
      o = width
      ws = width * 2.0
      while j < c
        matrix = new THREE.Matrix4();
        _x = j * width - w * 0.5
        _y = -width
        matrix.makeScale(ws, ws, ws)
        matrix.setPosition(x + _x + o, y + _y + o, _z)
        m.setMatrixAt i, matrix

        matrix = new THREE.Matrix4();
        _x = -width
        _y = j * width - w * 0.5
        matrix.makeScale(ws, ws, ws)
        matrix.setPosition(x + _x + o, y + _y + o, _z)
        m.setMatrixAt i + 1, matrix
        j += 2;
        i += 2

    return m

  tube : (c, length, geom, material) ->
    # world.models.nine.geometry
    @count = c
    m = new THREE.InstancedMesh( geom, material, @count);

    s = length / c
    for i in [0..@count - 1]
      matrix = new THREE.Matrix4();
      x = 0
      y = 0
      z = i * s
      # matrix.makeScale(ws, ws, ws)
      matrix.setPosition(x, y, z)
      m.setMatrixAt i, matrix


    return m

  crosstube : (segments, c, x, y, w, zs, geom, material) ->
    # world.models.nine.geometry
    @count = c * 4 * 2 * segments
    ws = 100
    m = new THREE.InstancedMesh( geom.clone().rotateY(Math.PI * 0.5).scale(ws,ws,ws), material, @count);

    i = 0

    r = 80
    for s in [0..segments - 1]
      _z = s * zs
      phase = 0
      r2 = r * 0.5
      j = 0
      o = 0

      for p in [0..3]
        t = p / 4
        _x = Math.cos(Math.PI * t * 2) * r
        _y = Math.sin(Math.PI * t * 2) * r
        matrix = new THREE.Matrix4();
        matrix.makeRotationAxis new THREE.Vector3(0,0,1), Math.PI * 2 * (t - 0.5)
        # matrix.makeRotationAxis new THREE.Vector3(0,,0), Math.PI * 0.5
        matrix.setPosition(x + _x + o, y + _y + o, _z - 200)
        m.setMatrixAt i, matrix
        i += 1
      r -= 10
    m
  shader : "basic"
  create_logo : (g, m, c) ->
    l = new THREE.InstancedMesh g, m, c
    rs = 10
    for i in [0..c - 2]
      matrix = new THREE.Matrix4();
      t = i / c
      # matrix = new THREE.Mesh(lg, lm, {transparent : true, alphaTest : 0.6})
      # m.position.set 0, -100, 0
      # l.rotateX Math.PI * -0.5
      # matrix.makeRotationAxis new THREE.Vector3(0,1,0), Math.PI * 2 * (t - 0.5)
        # matrix.makeRotationAxis new THREE.Vector3(0,,0), Math.PI * 0.5
      # ph = Math.random() * Math.PI * 2
      ph = t * Math.PI * 2 * 8
      rs = 100
      # rs = (1 - t) * 70 + (Math.random() * 60) + 10
      ti = i
      matrix.setPosition(Math.cos(ph) * (rs), Math.sin(ph) * (rs), - ti - 20)
      l.setMatrixAt i, matrix

    matrix = new THREE.Matrix4();
    matrix.makeScale(8, 8, 2)
    matrix.setPosition(0,0, -c - 10)
    l.setMatrixAt c - 1, matrix


    l
  init : (world) -> 
    @clock = new THREE.Clock(true)
    @material = world.mats.basic
    @material.alphaTest = 0.6
    @material.uniforms.color.value = new THREE.Color Colors.aqua
    @material.uniforms.color2.value = new THREE.Color Colors.aqua
    @material.uniforms.target.value = @target
    @material.uniforms.blend_freq.value = 1.0

    @material_ring = world.mats.basic.clone()
    @material_ring.alphaTest = 0.6
    @material_ring.uniforms.color.value = new THREE.Color Colors.yellow
    @material_ring.uniforms.color2.value = new THREE.Color Colors.white
    @material_ring.uniforms.target.value = @target
    @material_ring.uniforms.blend_freq.value = 0.05

    @material_clouds = world.mats.clouds.clone()
    @material_clouds.uniforms.color.value = new THREE.Color Colors.white
    @material_clouds.uniforms.color2.value = new THREE.Color Colors.aqua
    @material_clouds.uniforms.spatial_blend.value = new THREE.Vector3(0,0.4,0)

    @material_water = world.mats.vibrate.clone()
    @material_water.uniforms.color.value = new THREE.Color Colors.aqua
    @material_water.uniforms.color2.value = new THREE.Color Colors.blue
    @material_water.uniforms.spatial_blend.value = new THREE.Vector3(0,0.4,0.3)


    @material_tube = world.mats.vibrate.clone()
    @material_tube.uniforms.color.value = new THREE.Color Colors.pink
    @material_tube.uniforms.color2.value = new THREE.Color Colors.grey
    @material_tube.uniforms.spatial_blend.value = new THREE.Vector3(0.0,0.0,1.0)
    @material_tube.uniforms.blend_freq.value = 100.0



    @material_cross = world.mats.basic.clone()
    @material_cross.uniforms.color.value = new THREE.Color Colors.pink
    @material_cross.uniforms.color2.value = new THREE.Color Colors.yellow
    @material_cross.uniforms.spatial_blend.value = new THREE.Vector3(0,0.0,1.0)
    @material_cross.uniforms.blend_freq.value = 0.01
    # @material_cross.uniforms.blend_freq.value = 100.0
    # @material_tube.uniforms.color.value = new THREE.Color Colors.yellow


    @mesh = new THREE.Group()

    @grass = @dunes(world.models.one.geometry, @material)
    @water = @plain(world.models.nine.geometry.clone().rotateZ(Math.PI), 8, 8, 200, 500, 10, 4,@material_water)
    ts = 60
    @tub = @tube(4, 200, world.models.ring.geometry.clone().scale(ts, ts, ts), @material_tube)
    @clouds = @plain(world.models.center.geometry, 19, 8, 800, 300, 40, 1,@material_clouds)
    @rings = @ring(12, 10, 240, world.models.nine.geometry, @material_ring)
    @rings2 = @ring(12, 10, 300, world.models.nine.geometry, @material_ring)

    @cross = @crosstube(3, 1, 0,0,200, 80, world.models.arrow.geometry, @material_cross)


    @material_logo = world.mats["clouds"].clone()
    # @material_logo.alphaTest = 0.6
    # @material_logo.depthTest = false
    # @material_logo.uniforms.color.value = new THREE.Color Colors.aqua
    @material_logo.uniforms.color.value = new THREE.Color "#ffffff"
    @material_logo.uniforms.color2.value = new THREE.Color "#ffffff"
    @material_logo.uniforms.target.value = @target
    @material_logo.uniforms.blend_freq.value = 5.0

    s = 20
    @logo = @create_logo world.models.logo.geometry.clone().scale(s,s,s * 0.3), @material_logo, 150
    # @logo.renderOrder = 10000
    
    @logo.rotateX Math.PI * -0.5


    @cross.rotateX Math.PI * 0.5

    @mesh.add @grass
    @mesh.add @rings
    @mesh.add @rings2
    @mesh.add @clouds
    @mesh.add @water
    @mesh.add @tub
    @mesh.add @cross
    @mesh.add @logo

    @mesh.position.set -20, 0,0

    @tub.rotateX Math.PI * 0.5
    # @mesh = @cross(8, 18, 0,0,100, 16, world.models.one.geometry, @material)
  set_x : (m, x) ->
    m.position.set x, m.position.y, m.position.z
  time : 0
  last_scroll : 0
  update : (dt, scroll) ->
    sine = Math.sin(@clock.elapsedTime * 0.5)
    t = @clock.getElapsedTime()
    cl = (x) -> clamp(x, 0, 1)

    if scroll isnt last_scroll
      tt = t * 0.02
      last_scroll = scroll
      scroll = clamp scroll, 0, 0.9999999

      @material.uniforms.color2.value = new THREE.Color(Colors.aqua).lerp(new THREE.Color(Colors.green),fract(scroll * 3))
      @material_logo.uniforms.color2.value = new THREE.Color("#ffffff").lerp(new THREE.Color(Colors.aqua),cl(scroll - 0.8) * (1.0 / 0.2))
      @material_clouds.uniforms.color_offset.value = fract(scroll * 10)

      @grass.position.set cl(scroll - 0.5) * 10000, -100 - (scroll) * 400, -10 + scroll * 1000
      @rings.position.set 1500 * cl(scroll - 0.5), 0, -200 + scroll * 900
      @rings.setRotationFromAxisAngle new THREE.Vector3(0, 0, 1), (Math.PI / 12) + scroll * 10.0 - tt
      @rings2.position.set 1500 * cl(scroll - 0.5), 0, -150 + scroll * 900
      @rings2.setRotationFromAxisAngle new THREE.Vector3(0, 0, 1), scroll * -10.0 + tt
      gw = 1500
      @clouds.position.set -350 + -gw + cl(scroll) * gw * 2, 100, -150 + scroll * 100
      @water.position.set -200, -350 + 1600 * cl(scroll - 0.15), -80
      @tub.position.set 0, -210 + 450 * scroll, 0
      @cross.position.set 0, -820 + scroll * 800, 0
      @cross.rotateZ dt * (1 - scroll + 0.05)  * 0.5

      @logo.position.set 0, -600 + cl(scroll - 0.5) * 1300, 0
      lt = cl(scroll - 0.8) * 5
      # s =  10 - 9 * lt
      # @logo.scale.set s,s,s

      @super.camera.position.set -20, 0, 0
      @super.camera.lookAt(new THREE.Vector3(-20,-100 * cl(scroll - 0.3) + 10,-100 * (1.001 - scroll)))
    # scroll = 0.96
    s2 = 30
    d = 100
    

    @material.uniforms.color_shift.value = fract(@material.uniforms.color_shift.value + dt * 0.1)


    @material_logo.uniforms.color_offset.value = t * 0.1
    @material_cross.uniforms.color_offset.value = fract(t * 0.1)
    @material_cross.uniforms.u_time.value = t
    @material_logo.uniforms.u_time.value = t * 0.01
    @material_ring.uniforms.color_offset.value = t * 0.1
    @material_clouds.uniforms.u_time.value = t * 0.1
    @material_water.uniforms.u_time.value = t * 5
    @material_water.uniforms.vibrate_select.value = 1.0
    @material_water.uniforms.vibration.value = 0.5
    # @material_water.uniforms.ending.value = 0.1 * Math.sin(scroll * 10)
    @grass.setRotationFromAxisAngle new THREE.Vector3(0,0 , 1), sine * 0.1
    # @logo.rotateOnAxis new THREE.Vector3(0, 0, 1), dt * 0.05
    # $("#english").html scroll

class Stage
  constructor : (@levels) ->
  current : 0
  finished : () -> 
    @current >= @levels.length
  next : () ->
    @current += 1
    @finished()
    
  level : () -> 
    if @finished()
      Empty
    else 
      @levels[@current]

Stages = [
  new Stage([Tube, Tube2])
  new Stage([Circles, Circles2, Circles3])
  new Stage([Arrows, ArrowsS, ArrowsR])
  new Stage([Grid, GridR, GridC])
  new Stage([Spikes, SpikesS])
  new Stage([Crosses, Crosses2, Crosses3])
  new Stage([Triangle, Triangle2])

  new Stage([Empty, Final, Ending])
  new Stage([WinR])
]

# console.log Stages.map((s)-> s.levels.length).reduce((a, v) -> a + v)
